import React__default from 'react';
import { Label as Label$2 } from './Label.styles.js';

var Label = function Label(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height,
    _ref$labelType = _ref.labelType,
    labelType = _ref$labelType === void 0 ? null : _ref$labelType,
    _ref$labelRef = _ref.labelRef,
    labelRef = _ref$labelRef === void 0 ? null : _ref$labelRef,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? null : _ref$text;
  if (!text) return null;
  return /*#__PURE__*/React__default.createElement(Label$2, {
    className: "package-label",
    ref: labelRef,
    height: height,
    labelType: labelType,
    dangerouslySetInnerHTML: {
      __html: "".concat(text).trim()
    }
  });
};

/* eslint-enable react/no-danger */
var Label$1 = Label;

export { Label$1 as default };
//# sourceMappingURL=Label.js.map
